import React from 'react';

import Routes from './Routes';
import Menu from './Menu';

import { EnvFrame } from '../auth/accessToken';
import * as reducer from './reducer';

const Reports = () => (
    <EnvFrame>
        <Menu />
        <Routes />
    </EnvFrame>
);

export { Reports, reducer };
